import React from 'react';
import { BaseModal, Button } from '@cokitchen/cokitchen-components';

type Props = {
  title: string;
  description: string;
  open: boolean;
  loading: boolean;
  hideEmoji?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ConfirmTrafficModal = (props: Props) => {
  const { open, title, description, loading, hideEmoji, onClose, onConfirm } = props;

  return (
    <BaseModal isOpen={open} title='' onRequestClose={onClose}>
      <div className='flex flex-col gap-12'>
        <div className='flex flex-col items-center gap-3'>
          {!hideEmoji ? <p className='text-[40px]'>😓</p> : null}
          <article className='max-w-[389px] flex flex-col gap-2 text-center'>
            <p className='font-medium'>{title}</p>
            <p className='text-sm text-[#858585]'>{description}</p>
          </article>
        </div>

        <div className='flex items-center gap-4'>
          <Button small variant='outline' color='primary' onClick={onClose}>
            Cancel
          </Button>
          <Button small variant='block' color='primary' onClick={onConfirm} loading={loading}>
            Confirm
          </Button>
        </div>
      </div>
    </BaseModal>
  );
};

export default ConfirmTrafficModal;
